/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { ButtonGroup, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { Button, Table } from "../../components"
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook"
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice"
import { ArchiveFacilities } from "./ArchiveFacilities"
import { toast } from "react-toastify";


const ListOfFacilities = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { AllFacilitiesData , errorMessage } = useAppSelector(state => state.facilityList)
  const [archive, setArchive] = useState(false);
  const [deleteId, setDeleteId] = useState("")

  useEffect(() => {
    dispatch(AllFacilitiesList(""))
  }, [])

  if (errorMessage) {
    toast.error(errorMessage.message)
  }

  const FacilityHeader = ['Facility Name', 'Address', 'Created At', 'Status']
  const FacilityAccessor = ['name', 'address', 'createdAt', 'status']
  const columns = React.useMemo(
    () => FacilityHeader.map((item, index) => ({
      Header: item,
      accessor: FacilityAccessor[index],
    }
    )), [])

  const handleAdd = () => {
    navigate("/add-facility")
  }

  const handleEdit = (id: string) => {
    navigate("/update-facility", { state: id })
  }

  const handleUserInfo = (id: string) => {
    navigate("/facility-info", { state: id })
  }

  const HandleDelete = (id: string) => {
    setArchive(true)
    setDeleteId(id)
  }

  return (
    <>
      <Card>
        <Card.Body className="pb-0">
          <div className="page-title align-items-center d-flex justify-content-between">
            <Card.Title className="mb-0">Facility List</Card.Title>
            <ButtonGroup>
              <Button onClick={handleAdd} type="button" bname="Add Facility" name="add-facility" id="add-facility" className="btn btn-primary rounded-1"></Button>
            </ButtonGroup>
          </div>
        </Card.Body>
        <Table columns={columns} data={AllFacilitiesData} handleEdit={handleEdit} HandleShow={handleUserInfo} HandleDelete={HandleDelete} />
        <ArchiveFacilities setArchive={setArchive} archive={archive} id={deleteId} />
      </Card>
    </>
  )
}

export { ListOfFacilities }
